import classNames from 'classnames'
import React from 'react'
import Button from './button'
import Grid from './grid'
import Card from './card'
import Container from './container'
import Link from './link'
import Media from './media'

export default function FeatureCards({ header, cards, footer, design }) {
  const { text, sponsor } = header ?? {}
  const { banner, heading, description } = text ?? {}
  const { intro, image, link: sponsorLink } = sponsor ?? {}
  const { link: footerLink } = footer ?? {}
  const { columns } = design ?? {}
  // TODO: Replace with real girl
  const breaker = +columns === 2

  return (
    <section className={breaker ? 'breaker bg-primary' : 'bg-primary'}>
      <div
        className={classNames(
          'standard-spacing',
          breaker ? 'bg-secondary text-primary' : 'bg-primary text-secondary'
        )}>
        <Container>
          <Grid className="items-center text-center">
            <div className="col-span-12 md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3">
              {banner && (
                <div
                  className="accent-lg leading-relaxed flex flex-col md:flex-row items-center justify-center"
                  dangerouslySetInnerHTML={{
                    __html: banner.replaceAll(/\*/g, '<svg class="h-3 md:h-4 fill-primary inline-block my-2 md:my-0 md:mx-2" viewBox="0 0 139.94 140.57"><path d="M0 70.37C31.22 54.94 54.4 31.53 70 0c7.06 15.64 17.03 29.14 29.04 41.21 12 12.06 25.44 22.04 40.91 29.06-31.22 15.51-54.52 38.91-70.11 70.3C54.51 109.26 31.16 85.84 0 70.37Zm69.77 43.44c11.59-17.55 25.88-31.91 43.15-43.44C95.6 58.89 81.39 44.39 69.84 27.15 58.3 44.51 44.02 58.77 26.67 70.27c8.92 5.51 16.5 12.33 23.72 19.53 7.25 7.22 13.85 14.99 19.38 24Z"/></svg>')
                  }}
                />
              )}
              {heading && <h2 className={classNames(
                'mt-4',
                breaker ? 'heading-4xl' : 'heading-3xl'
              )}>{heading}</h2>}
            </div>
            {description && (
              <p
                className={classNames(
                  'mt-4 body-lg col-span-12 md:col-span-8 md:col-start-3 lg:col-span-8 lg:col-span-6 lg:col-start-3',
                  breaker ? 'text-primary' : '420:text-secondary exxxotica:text-tertiary'
                )}
              >
                {description}
              </p>
            )}
            {(!breaker && (intro || image)) && (
              <div className="col-span-12">
                {intro && <div className="accent-bs">{intro}</div>}
                {sponsorLink ? (
                  <Link className="mt-4 mx-auto w-32" {...sponsorLink}>
                    <Media className="brightness-0 filter" {...image} />
                  </Link>
                ) : (
                  <Media className="mt-4 mx-auto w-32 filter brightness-0" image={image} />
                )}
              </div>
            )}
          </Grid>
        </Container>
      </div>
      {cards?.length && (
        <div className="relative">
          {breaker && (
            <div
              className={classNames('absolute w-full bg-secondary')}>
              <Container>
                <Grid>
                  {/* ITS THIS ONE */}
                  <div
                    className={classNames(
                      'max-w-screen col-span-12 -mx-8 grid w-full gap-8 pt-1 md:px-24 lg:mx-0 lg:grid lg:grid-cols-12 lg:px-0',
                      breaker
                        ? 'lg:col-span-10 lg:col-start-2'
                        : 'lg:col-start-2'
                    )}>
                    <div
                      className={classNames(
                        'w-[calc(100vw-96px)] flex-none border-x-2 border-t-2 border-transparent md:w-[calc(100vw-192px)] lg:w-auto',
                        breaker ? 'lg:col-span-6' : 'lg:col-span-4'
                      )}>
                      <div className="aspect-[3/2] lg:aspect-[5/3]" />
                    </div>
                  </div>
                </Grid>
              </Container>
            </div>
          )}
          <Container className="bg-primary pb-16 md:pb-24">
            <ul
              className={classNames(
                'scrollbar-hidden max-w-screen relative -mx-8 flex snap-x snap-mandatory scroll-px-8 gap-8 overflow-x-scroll lg:overflow-x-visible px-8 pt-0.5 pb-6 md:scroll-px-24 md:px-24 lg:mx-0 lg:grid lg:grid-cols-12 lg:px-0',
                breaker ? 'lg:col-span-10 lg:col-start-2' : 'lg:col-start-2'
              )}>
              {cards.map((card, index) => (
                <li
                  key={index}
                  className={classNames(
                    'cards-card w-[calc(100vw-96px)] flex-none snap-center md:w-[calc(100vw-192px)] lg:w-auto',
                    breaker
                      ? 'lg:col-span-5 lg:odd:col-start-2'
                      : 'lg:col-span-4'
                  )}>
                  <Card
                    type="vertical"
                    size={breaker ? 'lg' : 'sm'}
                    {...card}
                  />
                </li>
              ))}
            </ul>
            {breaker ? (
              <div className="withBreaker"></div>
            ) : (
              <div className="withoutBreaker"></div>
            )}
            <Grid className="mt-12">
              {footerLink && (
                <Button
                  className="col-span-12 justify-self-center"
                  color="black"
                  outline
                  size="lg"
                  {...footerLink}
                />
              )}
            </Grid>
          </Container>
        </div>
      )}
    </section>
  )
}
